import { render } from "./ProformaDetalle.vue?vue&type=template&id=8456bc9e&scoped=true"
import script from "./ProformaDetalle.vue?vue&type=script&lang=js"
export * from "./ProformaDetalle.vue?vue&type=script&lang=js"

import "./ProformaDetalle.vue?vue&type=style&index=0&id=8456bc9e&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8456bc9e"]])

export default __exports__